import ExpandableContent from '@/shared/crisp/ExpandableContent';
import Div from '@/shared/Div';
import React, { memo, useLayoutEffect, useRef, useState } from 'react';

interface ProductDescriptionProps {
  dataTestId?: string;
  title?: string;
  overview?: string;
  richOverview?: string;
}

const ProductDescription = (props: ProductDescriptionProps) => {
  const {
    dataTestId = 'Product-Description',
    title = 'About this product',
    richOverview,
    overview,
  } = props;
  const ref = useRef<HTMLDivElement>(null);
  const [contentHeight, setContentHeight] = useState(0);

  useLayoutEffect(() => {
    if (ref.current) {
      const { height } = ref.current.getBoundingClientRect();
      setContentHeight(height);
    }
  }, []);
  return (
    <Div dataTestId={dataTestId} className="mt-s9 md:mt-s10">
      <Div className="overflow-hidden text-ellipsis text-h-3 text-black mb-s4 lg:mb-s5 lg:text-hd-3">
        {title}
      </Div>
      <ExpandableContent contentHeight={contentHeight}>
        <Div
          className="font-primary"
          ref={ref}
          dangerouslySetInnerHTML={{ __html: richOverview || `<p>${overview}</p>` }}
          forceRender
        />
      </ExpandableContent>
    </Div>
  );
};

export default memo(ProductDescription);
